export enum UserStatus {
  ARCHIVED = "ARCHIVED",
  ACTIVE = "ACTIVE",
}

export const UserStatusEnumMapping: Record<UserStatus, string> = {
  [UserStatus.ARCHIVED]: "user.status.archived",
  [UserStatus.ACTIVE]: "user.status.active",
};

export interface UserStatusInterface {
  id: UserStatus;
  value: string;
}
